export const categories = {
  'Active Listings': 'activeListings',
  Open: 'openOrders',
};

export const views = {
  activeListings: 'Active Listings',
  open: 'Open',
  completed: 'Completed',
};
